import { useState } from 'react';

const LoaderComponent: React.FC<{ className?: string; height?: string; width?: string; children?: any }> = ({
  className = '',
  height,
  width,
  children,
}) => {
  let [loading, setLoading] = useState(true);
  let [color, setColor] = useState('#ffffff');

  return (
    <div className="loading_wrp">
      <div className="loading_bx">{children ? children : 'Loding...'}</div>
    </div>
  );
};

export default LoaderComponent;
